import { FC, HTMLAttributes } from "react";
import Image from "next/image";
import clsx from "clsx";

// --------------------------------------------------------------------

export type IMaturityModelSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  imageUrl?: string;
};

const MaturityModelSection: FC<IMaturityModelSectionProps> = (props) => {
  const { heading, imageUrl, className, ...other } = props;

  return (
    // No outer section padding — the black band sits flush against the
    // sections above and below for a deliberate edge-to-edge feel.
    <section>
      <div
        className={clsx("flex w-full justify-center bg-black-900", className)}
        {...other}
      >
        <div className="w-full">
          {/* section title — canonical clamp + light font weight,
              centered to match the other redesigned home sections
              (Philosophy / Solution / Services / Industries). */}
          {heading && (
            <div className="container w-full pt-8 lg:pt-16">
              <h2 className="mx-auto max-w-3xl break-words text-center font-bricolage-grotesque text-[clamp(1.375rem,3vw+0.75rem,3rem)] font-extralight !leading-[1.1] tracking-tight text-white">
                {heading}
              </h2>
            </div>
          )}

          {/* model image */}
          {imageUrl && (
            <div className="mx-auto max-w-[1440px] md:mt-8 lg:mt-14">
              <Image
                src={imageUrl}
                alt="maturity model image"
                width={1440}
                height={716}
                style={{
                  height: "auto",
                  width: "auto",
                }}
                className="w-full bg-cover bg-center"
                unoptimized={true}
                quality={100}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default MaturityModelSection;
